const removeDomElement = ({ element }) => {
  if (!element) {
    return false;
  }

  const parent = element.parentElement;

  if (!parent) {
    return false;
  }

  return parent.removeChild(element);
};

// noinspection JSUnusedGlobalSymbols
export default removeDomElement;
